module.exports = __webpack_public_path__ + "/bundle/asset/faq-1-3-277d59a248c4f0af28a38c93c7b1ece9.png";